module.exports = [
    "Wali",
    "Ugali",
    "Nyama ya ng'ombe",
    "Nyama ya mbuzi",
    "Siagi",
    "Kabichi",
    "Spinachi",
    "Kisamvu",
    "Samaki",
    "Mayai",
    "Kunde",
    "Maharagwe",
    "Mbaazi",
    "Mboga za majani",
    "Dagaa",
    "Kumbikumbi",
    "Senene",
    "Maini",
    "Machungwa",
    "Mchicha",
    "Kabichi",
    "Mihogo",
    "Viazi",
];